import firebase from "firebase";

export async function GetDeliveryWithPid(order_id) {
  const { result, data } =
    (await firebase.functions()
      .httpsCallable('GetDelivery')({
        order_id: order_id
      })).data;
  try {
    if (!result) {
      return [];
    } else {
      return data;
    }
  } catch (err) {
    console.log(err);
    return [];
  }
}

export async function GetDeliveryList() {
  const response = (await firebase.functions().httpsCallable('GetDeliveries')({})).data;
  try {
    if (!response.result) {
      return [];
    } else {
      return response.data;
    }
  } catch (err) {
    console.log(err);
    return [];
  }
}